import { ServiceAdjustment } from 'store/types'

type Adj = { group: string; reason: string; amount: number }

export function normalizeCas(casList: ServiceAdjustment[]): Adj[] {
  const result: Adj[] = []

  for (const cas of casList) {
    const group = cas.claimAdjustmentGroupCode

    for (let i = 1; i <= 6; i++) {
      const amountStr = (cas as any)[`adjustmentAmount${i}`]
      const reason = (cas as any)[`adjustmentReasonCode${i}`]

      if (!amountStr) continue

      const amount = Number(amountStr)

      if (Number.isNaN(amount)) continue

      result.push({ group, reason, amount })
    }
  }

  return result
}

// CARCs that need biller action (appeal / correct / rebill) rather than a
// routine contractual adjustment: missing info (16), duplicate (18), coverage
// terminated (26/27), timely filing (29), not medically necessary (50),
// non-covered (96), wrong payer (109), max benefit (119), no auth (197),
// not covered by plan (204), exceeds contracted maximum (222)
export const ACTIONABLE_DENIAL_CODES = ['16', '18', '26', '27', '29', '31', '50', '96', '109', '119', '197', '204', '222']
